
import React from 'react';
import HeaderComponent from './commonComponent/HeaderComponent';

function Overview() {
  return (
    <>
   
        <div className="container-fluid py-1">
        <div className="container py-1">
            <div className="row">
            <img className="img-fluid rounded" src="img/carousel-1.jpg" alt=""/>
                
                
                </div>
                <br/>
                <div className="row">

                <p>At Yash Jain & Associates, we provide a dynamic and challenging environment for lawyers and support professionals. Our focus is on fostering careers that are intellectually enriching, globally oriented, and deeply satisfying on a personal level. Our firm champions a team-centric culture and is committed to supporting your professional development within a nurturing framework that allows you to refine and perfect your skills.
We are looking for lawyers who excel in both written and verbal communication, demonstrate a proactive approach to learning, and possess the ability to analyze issues and devise solutions from both legal and business standpoints. Commitment, leadership qualities, and the ability to thrive in a team environment are essential attributes for our ideal candidate.
</p>
                
                </div>
        </div>
        </div>

    

    </>
  );
}

export default Overview;
